import React, { useState, useEffect } from 'react';
import { Form, Button, Col, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSave, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';
import { avisoError, avisoCargando, avisoCorrecto } from '../../AvisosMensajes/MensajesSwalf';
import './RegistroUsuarios.scss';

//Redux
import { useDispatch, useSelector } from 'react-redux';
import { updateStateModalBasic } from '../../../../actions/modalActions';
import { listarAreasTrabajadores, obtenerListaClasificacionTrabajadores } from '../../../../actions/trabajadoresActions';
import { verificarDniExistente, agregarRolAUsuario } from '../../../../actions/userActions';

const ROLES_TRABAJADOR = [
  { value: '1',  label: 'Administración' },
  { value: '4',  label: 'Académica' },
  { value: '5',  label: 'Posventa' },
  { value: '6',  label: 'Contabilidad' },
  { value: '7',  label: 'Tutoría' },
  { value: '8',  label: 'T.I.C' },
  { value: '9',  label: 'RR.HH' },
  { value: '10', label: 'Gerencia' },
  { value: '11', label: 'Ventas' },
  { value: '12', label: 'Marketing' },
  { value: '13', label: 'Jefe Ventas' },
  { value: '14', label: 'Reclutador' },
  { value: '15', label: 'UX Manager' },
  { value: '16', label: 'Editor Audiovisual' },
  { value: '17', label: 'HRBP' },
];

const RegistroUsuarios = ({ handleSubmitAction, docenteState, editar, areas }) => {

  const dispatch = useDispatch()
  const history = useHistory()
  const { datos: listaClasificaciones = [] } = useSelector(state => state.trabajadores.clasificacion);
  const { todo: listaAreas = [] } = useSelector(state => state.trabajadores.areas);
  const docente = useSelector(state => state.profesores.profesor)
  const stateNuevoDocente = useSelector(state => state.profesores.nuevoDocente)
  const [datosDocente, setDatosDocente] = useState(initialState())
  const [dniInfo, setDniInfo] = useState(null)
  const [verificandoDni, setVerificandoDni] = useState(false)
  const [rolNuevo, setRolNuevo] = useState('')

  const {
    nombre_usuario,
    usuario,
    password,
    apellido_usuario,
    fecha_nac,
    email,
    dni,
    direccion,
    provincia,
    departamento,
    distrito,
    celular,
    clasificacion,
    area
  } = datosDocente;

  const handleChange = e => {
    setDatosDocente({
      ...datosDocente,
      [e.target.name]: e.target.value
    })
  }

  const handleCloseModal = () => {
    dispatch( updateStateModalBasic() )
    setDatosDocente( initialState() )
    setDniInfo(null)
    setRolNuevo('')
  }

  const handleDniCheck = async (dniValue) => {
    if (!dniValue || String(dniValue).length < 7) return
    setVerificandoDni(true)
    const info = await dispatch(verificarDniExistente(String(dniValue)))
    setDniInfo(info)
    setVerificandoDni(false)
    setRolNuevo('')
  }

  const agregarRol = async () => {
    if (!rolNuevo) { avisoError('Selecciona el rol a agregar'); return }
    avisoCargando('Agregando rol...')
    const res = await dispatch(agregarRolAUsuario(dniInfo.id_usuario, parseInt(rolNuevo)))
    if (res.estado) {
      avisoCorrecto(res.mensaje)
      handleCloseModal()
    } else {
      avisoError(res.mensaje)
    }
  }

  const rolesYaAsignados = dniInfo && dniInfo.existe
    ? [String(dniInfo.rol_principal.id), ...(dniInfo.roles_adicionales || []).map(r => String(r.id_tp_nivel_usuario))]
    : []
  const rolesDisponibles = ROLES_TRABAJADOR.filter(r => !rolesYaAsignados.includes(r.value))

  const handleSubmit = async e => {
    e.preventDefault();
    if (nombre_usuario === '' || apellido_usuario === '' || usuario === ''
      || password === '' || dni === '') {
      avisoError('Faltan llenar campos obligatorios')
      return;
    }
    await handleSubmitAction(datosDocente)
    dispatch( updateStateModalBasic() )
  }

  useEffect(() => {
    if (stateNuevoDocente) {
      history.push(`/profesores/editar/${docente.id_docente}`) 
    }
  }, [stateNuevoDocente])

  useEffect(() => {
    if (docenteState) {
      setDatosDocente(docenteState)
    }
  }, [docenteState])

  useEffect(() => {
    dispatch(obtenerListaClasificacionTrabajadores());
    dispatch(listarAreasTrabajadores());
  }, [])

  return ( 
    <div className="registro-docente">
      <Form onSubmit={handleSubmit}>
        <Modal.Body className="datos-personales__content">
          <Form.Group>
            <Form.Label className='label-required'>Nombre</Form.Label>
            <Form.Control type="text" name='nombre_usuario' value={nombre_usuario} onChange={handleChange} />
          </Form.Group>
          <Form.Group>
            <Form.Label className='label-required'>Apellido</Form.Label>
            <Form.Control type="text" name='apellido_usuario' value={apellido_usuario} onChange={handleChange} />
          </Form.Group>
          <Form.Row >
            <Form.Group as={Col} md={6}>
              <Form.Label>Fecha de nacimiento</Form.Label>
              <Form.Control type="date" name='fecha_nac' value={fecha_nac} onChange={handleChange} />
            </Form.Group>
            <Form.Group as={Col} md={6}>
              <Form.Label className='label-required'>DNI</Form.Label>
              <Form.Control
                type="text"
                name='dni'
                value={dni}
                onChange={e => {
                  handleChange(e)
                  setDniInfo(null)
                  if (!editar && e.target.value.length >= 8) {
                    handleDniCheck(e.target.value)
                  }
                }}
                onBlur={() => { if (!editar) handleDniCheck(dni) }}
                placeholder={verificandoDni ? 'Verificando...' : ''}
              />
              {verificandoDni && <small className="text-muted">Verificando DNI...</small>}
              {dniInfo && !dniInfo.existe && <small className="text-success">✓ DNI disponible</small>}
            </Form.Group>
          </Form.Row>
          {dniInfo && dniInfo.existe && (
            <div className="alert alert-warning mt-2" style={{borderRadius:'8px'}}>
              <strong>Este DNI ya está registrado</strong>
              <p className="mb-1" style={{fontSize:'14px'}}>
                <strong>{dniInfo.nombre_usuario} {dniInfo.apellido_usuario}</strong>
                {' — '}{dniInfo.rol_principal.nombre}
                {dniInfo.roles_adicionales && dniInfo.roles_adicionales.length > 0 && (
                  <span> + {dniInfo.roles_adicionales.map(r => r.nombre_tp_nivel_usuario).join(', ')}</span>
                )}
              </p>
              <p className="mb-2" style={{fontSize:'13px', color:'#856404'}}>
                Puedes agregar un rol adicional a esta persona en vez de crear un usuario nuevo.
              </p>
              {rolesDisponibles.length > 0 ? (
                <div className="d-flex align-items-center" style={{gap:'8px'}}>
                  <select value={rolNuevo} onChange={e => setRolNuevo(e.target.value)} className="form-control" style={{width:'auto', minWidth:'180px'}}>
                    <option value="">-- Seleccionar rol --</option>
                    {rolesDisponibles.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
                  </select>
                  <button type="button" className="btn btn-warning btn-sm" onClick={agregarRol} disabled={!rolNuevo}>Agregar rol</button>
                  <button type="button" className="btn btn-link btn-sm" onClick={() => setDniInfo(null)}>Cancelar</button>
                </div>
              ) : (
                <p className="mb-0 text-success"><strong>Esta persona ya tiene todos los roles disponibles.</strong></p>
              )}
            </div>
          )}

          <Form.Group clasificacion='mt-3'>
            <Form.Label>Correo</Form.Label>
            <Form.Control type="email" name='email' value={email} onChange={handleChange} />
          </Form.Group>
          <Form.Group>
            <Form.Label>Dirección</Form.Label>
            <Form.Control type="text" name='direccion' value={direccion} onChange={handleChange} />
            <Form.Row className='mt-3'>
              <Col md={4}>
                <Form.Control
                  type="text"
                  name='departamento'
                  placeholder='Departamento'
                  value={departamento}
                  onChange={handleChange}
                />
              </Col>
              <Col md={4}>
                <Form.Control
                  type="text"
                  name='provincia'
                  placeholder='Provincia'
                  value={provincia}
                  onChange={handleChange}
                />
              </Col>
              <Col md={4}>
                <Form.Control
                  type="text"
                  name='distrito'
                  placeholder='Distrito'
                  value={distrito}
                  onChange={handleChange}
                />
              </Col>
            </Form.Row>
          </Form.Group>
          <Form.Group>
            <Form.Label>Celular</Form.Label>
            <Form.Control type="text" name='celular' value={celular} onChange={handleChange} />
          </Form.Group>
          {
            areas && <Form.Row>
              <Col md={6}>
                <Form.Label className='label-required'>Clasificación</Form.Label>
                <Form.Control as="select" name='clasificacion' defaultValue='' value={clasificacion} onChange={handleChange}>
                  <option disabled value=''>--Seleccionar--</option>
                  {
                    listaClasificaciones.map(clasificacion => (
                      <option
                        value={clasificacion.id_tp_clasificacion_usuario}
                        key={clasificacion.id_tp_clasificacion_usuario}
                      >
                        {clasificacion.nombre_clasificacion}
                      </option>
                    ))
                  }
                </Form.Control>
              </Col>
              <Col md={6}>
                <Form.Label className='label-required'>Área</Form.Label>
                <Form.Control as="select" defaultValue={''} name='area' value={area} onChange={handleChange}>
                  <option disabled value="">--Seleccionar--</option>
                  {
                    listaAreas.map(area => (
                      <option
                        value={area.id_tp_nivel_usuario}
                        key={area.id_tp_nivel_usuario}
                      >
                        {area.nombre_tp_nivel_usuario}
                      </option>
                    )) 
                  }
                </Form.Control>
              </Col>
            </Form.Row>
          }
          {
            !editar && <Form.Row className='mt-3'>
            <Col md={6}>
              <Form.Label className='label-required'>Usuario</Form.Label>
              <Form.Control type="text" name='usuario' value={usuario} onChange={handleChange} />
            </Col>
            <Col md={6}>
              <Form.Label className='label-required'>Contraseña</Form.Label>
              <Form.Control type="password" name='password' value={password} onChange={handleChange} />
            </Col>
          </Form.Row> 
          }
        </Modal.Body>
        <Modal.Footer className='text-right'>
          <Button
            variant='dark'
            className='btn-icon'
            type='button'
            onClick={() => handleCloseModal()}
          >
            <FontAwesomeIcon icon={faTrash} />
            Cancelar
          </Button>
          <Button
            type='submit'
            className='btn-icon'
            variant='info'
          >
            <FontAwesomeIcon icon={editar ? faSave : faPlus} />
            {
              editar ? 'Guardar' : 'Agregar'
            }
          </Button>
        </Modal.Footer>
      </Form>
    </div>
   );
}
 
export default RegistroUsuarios;

const initialState = () => (
  {
    nombre_usuario: '',
    apellido_usuario: '',
    fecha_nac: '',
    dni: '',
    direccion: '',
    distrito: '',
    provincia: '',
    departamento: '',
    celular: '',
    celular_ref: '',
    email: '',
    usuario: '',
    password: '',
    id_estado: '',
    clasificacion: '',
    area: ''
  }
)
